import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface FormFactorTableListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: FormFactorTableListGridActionCellRendererParams) => void;
    canEdit: (params: FormFactorTableListGridActionCellRendererParams) => boolean;
    canEnterEditMode: (params: FormFactorTableListGridActionCellRendererParams) => boolean;
    canRemove: (params: FormFactorTableListGridActionCellRendererParams) => boolean;
    remove: (params: FormFactorTableListGridActionCellRendererParams) => void;
    canUndoRemove: (params: FormFactorTableListGridActionCellRendererParams) => boolean;
    undoRemove: (params: FormFactorTableListGridActionCellRendererParams) => void;

}

@Component({
    selector: 'form-factor-table-grid-action-cell',
    template: `
    @if (params.data) {
      <button class="ace-btn has-icon btn-secondary grid-action-button" title="View details" (click)="params.viewDetails(params)">
        <i class="fa fa-external-link"></i>
      </button>
    }
    @if (params.canRemove(params)) {
      <button class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Remove" (click)="params.remove(params)">
        <i class="fa fa-times"></i>
      </button>
    }
    @if (params.canUndoRemove(params)) {
      <button class="ace-btn has-icon success-button grid-action-button" title="Undo Remove" (click)="params.undoRemove(params)">
        <i class="fa fa-undo"></i>
      </button>
    }
    `,
    standalone: false
})
export class FormFactorTableListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: FormFactorTableListGridActionCellRendererParams;

    agInit(params: FormFactorTableListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
